/**
 * author :sqa
 * base : api-config, http-config,  process.env ~config
 *
 *
 * example :
 *  httpServer[api-config](param, query, baseURL)
 *  param : send data
 *  query : url query params
 *  baseURL : process.env[baseURL]
 *
 * */

import api from './api';
import httpConfig from './http-config';
import Vue from 'vue';
import qs from 'qs';
import {Message} from 'element-ui';

const httpRequest = {
  get: (url, data) => new Promise((resolve, reject) => {
    httpConfig(url + (data ? '?' + qs.stringify(data) : '')).then(
      response => resolve(response.data),
    ).catch(error => {
      reject(error);
    });
  }),
  post: (url, data) => new Promise((resolve, reject) => {
    httpConfig.post(url, qs.stringify(data), {
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      timeout:5 * 60 *1000,
    }).then(response => resolve(response.data)).catch(error => {
      reject(error);
    });
  }),
  postJson: (url, data) => new Promise((resolve, reject) => {
    httpConfig.post(url, data, {
      headers: {'Content-Type': 'application/json'},
    }).then(response => resolve(response.data)).catch(error => {
      reject(error);
    });
  }),
  download: (url, data) => new Promise((resolve, reject) => {
    httpConfig.post(url, qs.stringify(data), {
      responseType: 'blob',
    }).then(response => {
      if (!response || !response.data) return;
      let _fileName = null;
      try {
        _fileName = response.headers['content-disposition'].split('=')[1];
      } catch (e) {
      }
      const fileName = decodeURIComponent(_fileName || data.downloadName ||
        'download-' + new Date().getTime());
      let blob = new Blob([response.data]);
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else { // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  }),
  postMutil: (url, data , uploadProgressHandler) => new Promise((resolve, reject) => {
    httpConfig.post(url, data, {
      headers: {'Content-Type': 'multipart/form-data'},
      timeout:5 * 60 *1000,
      onUploadProgress: uploadProgressHandler
    }).then(response => resolve(response.data)).catch(error => {
      reject(error);
    });
  }),
};

function HttpServer() {
  const _this = this;
  api.get = Object.assign(api.get, {
    authentication: '/authentication',
    logout: '/user/logout',
  });

  Object.keys(api).forEach(m => {
    const _api = api[m], _apiName = Object.keys(_api);
    _apiName.forEach(appName => _this.httpFactory(appName, _api[appName], m, this));
  });
}

HttpServer.prototype.httpFactory = (apiName, url, method, _this) => {
  _this[apiName] = (param, query, baseURL ,uploadProgressHandler) =>
    httpRequest[method](_this.urlLoad(method, baseURL, query, url), param,uploadProgressHandler);
};

HttpServer.prototype.urlLoad = (m, b, q, u) => {
  const globalConfig = Vue.prototype.globalConfig;
  const baseURL = globalConfig.domain[b || 'baseURL'];
  const list = u.split('/').filter(i => i.startsWith('{')).map(i => i.replace(/\{|\}/g, ''));
  let url = u;
  list.forEach(i => {
    url = url.replace('{' + i + '}', q[i]);
    delete q[i];
    JSON.stringify(q) === '{}' && (q = null);
  });
  return baseURL + (m === 'get' ? url : url + (q ? '?' + qs.stringify(q) : ''));
};

const getSingle = (fn => {
  let result;
  return () => result || (result = new fn());
})(HttpServer);

export default getSingle();



// WEBPACK FOOTER //
// ./src/http/http-server.js